import React from 'react';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

export function DhcdControls({
    start,
    total,
    visibleCount,
    perPage,
    setPerPage,
    setPage,
    perPageOptions,
    years = [],
    year,
    setYear,
}) {
    const router = useRouter();
    const {locale} = router;

    return (
        <div className="dhcd-controls">
            <label className="dhcd-select">
                {getLocaleContent(locale, 'page.shareholder-relations.number_per_page')}
                <select
                    value={perPage}
                    onChange={e => {
                        setPerPage(Number(e.target.value));
                        setPage(1);
                    }}>
                    {perPageOptions.map(n => (
                        <option key={n} value={n}>
                            {String(n).padStart(2, '0')}
                        </option>
                    ))}
                </select>
            </label>

            <div className="dhcd-filters">
                <label className="dhcd-select">
                    {getLocaleContent(locale, 'page.shareholder-relations.year')}
                    <select value={year} onChange={e => setYear(Number(e.target.value))}>
                        <option value="">{getLocaleContent(locale, 'page.shareholder-relations.total')}</option>
                        {years.map(n => (
                            <option key={n} value={n}>
                                {n}
                            </option>
                        ))}
                    </select>
                </label>

                <div className="dhcd-info">
                    {getLocaleContent(locale, 'page.shareholder-relations.show')} <strong>{start + 1}</strong>-
                    <strong>{Math.min(total, start + visibleCount)}</strong>{' '}
                    {getLocaleContent(locale, 'page.shareholder-relations.in_total_page')} <strong>{total}</strong>{' '}
                    {getLocaleContent(locale, 'page.shareholder-relations.new')}
                </div>
            </div>
        </div>
    );
}
